import doc             from '@widesk-core/decorators/doc';
import model           from '@widesk-core/decorators/model';
import MapServiceModel from '@/models/MapServiceModel';

@model.cacheDuration()
@model.urnResource('import_status')
@doc.path('/import_statuses/{?id}')
export default class ImportStatusModel extends MapServiceModel {
	private declare _tsFilters: {
		'reference': Map_ImportStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
		'reference': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Map_ImportStatusReference;
}